import React, { useEffect, useState } from 'react';
import { Box } from '@abyss/web/ui/Box';
import { Label } from '@abyss/web/ui/Label';
import { Button } from '@abyss/web/ui/Button';
import { useRouter } from '@abyss/web/hooks/useRouter';
import { IconSymbol } from '@abyss/web/ui/IconSymbol';
import { Link } from '@abyss/web/ui/Link';

export const AuthenticationError = () => {
  const { navigate } = useRouter();
  const [errorMessage, setErrorMessage] = useState<string>('');

  useEffect(() => {
    // Get error message from URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const urlErrorMessage = urlParams.get('error');

    if (urlErrorMessage) {
      setErrorMessage(decodeURIComponent(urlErrorMessage));
    }
  }, []);

  const tryAgain = () => {
    navigate('/sso');
  };

  return (
    <Box
      padding={40}
      css={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '20px',
        minHeight: '60vh',
        maxWidth: '50vw',
        backgroundColor: 'white',
      }}
    >
      <IconSymbol
        icon="shield_lock"
        color="$error1"
        size="96px"
        variant="outlined"
      />
      <Label
        size="xl"
        fontWeight="$bold"
        color="$primary1"
        css={{ textAlign: 'center' }}
      >
        Authentication Error
      </Label>

      <Label
        size="md"
        color="$gray6"
        css={{ textAlign: 'center', maxWidth: '500px' }}
      >
        {errorMessage ? (
          <>
            SSO Authentication failed: {errorMessage}
            <br />
            <br />
            <Link href="/login">Click here.</Link> to be redirected to the login
            page.
          </>
        ) : (
          <>
            Authentication Fail. <Link href="/login">Click here.</Link> to be
            redirected to the login page.
          </>
        )}
      </Label>
    </Box>
  );
};
